import React from "react";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import { Grid } from "@mui/material";
import styles from "./assistance.module.scss";

export const UniPageAnalyticsAssistance = () => {
  return (
    <section className={styles.section_assistance}>
      <div className="container">
        <Grid container spacing={5} alignItems="center">
          <Grid item sm={12} md={6}>
            <h2 className={styles.title}>
              Get One-to-One Assistance and Insight
            </h2>
            <p className={`${styles.sub_title} font-medium`}>
              Figuring out how best to navigate emerging target markets? Get in
              touch with our dedicated team of market experts for in-depth
              insight and personalised solutions for your institution!
            </p>

            <Link legacyBehavior href="/university/booking">
              <a className={`${styles.link} btn btn-bg btn-secondary`}>
                Learn More
              </a>
            </Link>
          </Grid>
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_assistance.png")}
                alt="Uni Assistance"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageAnalyticsAssistance;
